var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F6E3653E-7549-4CE7-9D0C-B22962C5DF9A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-3-Copy-18",
    transform: "translate(-1043.000000, -1246.000000)",
    fill: "#FF5043",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "share-(2)",
    transform: "translate(1043.000000, 1246.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2,0 L10.4,0 C9.9581722,0 9.6,0.3581722 9.6,0.8 C9.6,1.2418278 9.9581722,1.6 10.4,1.6 L13.2688,1.6 L6.6344,8.2344 C6.42643473,8.43525958 6.34302992,8.73270231 6.41624227,9.01240586 C6.48945463,9.2921094 6.7078906,9.51054537 6.98759414,9.58375773 C7.26729769,9.65697008 7.56474042,9.57356527 7.7656,9.3656 L14.4,2.7312 L14.4,5.6 C14.4,6.0418278 14.7581722,6.4 15.2,6.4 C15.6418278,6.4 16,6.0418278 16,5.6 L16,0.8 C16,0.3581722 15.6418278,0 15.2,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6,6.8704 C13.1581722,6.8704 12.8,7.2285722 12.8,7.6704 L12.8,13.4008 C12.7995588,13.9524601 12.3524601,14.3995588 11.8008,14.4 L2.5992,14.4 C2.04753991,14.3995588 1.60044115,13.9524601 1.6,13.4008 L1.6,4.1992 C1.60044115,3.64753991 2.04753991,3.20044115 2.5992,3.2 L7.5768,3.2 C8.0186278,3.2 8.3768,2.8418278 8.3768,2.4 C8.3768,1.9581722 8.0186278,1.6 7.5768,1.6 L2.5992,1.6 C1.16443244,1.60176316 0.00176315722,2.76443244 0,4.1992 L0,13.3992 C0.0008814191,14.8345924 1.16380845,15.9982353 2.5992,16 L11.7992,16 C13.2345924,15.9991186 14.3982353,14.8361915 14.4,13.4008 L14.4,7.6704 C14.4,7.2285722 14.0418278,6.8704 13.6,6.8704 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadMore);
export default __webpack_public_path__ + "static/media/readMore.a58a2dbb7bdbaf22f3305f517bd4b13e.svg";
export { ForwardRef as ReactComponent };